module.exports = __webpack_public_path__ + "static/p02_letreroPoste-e3bad5e8e0047fdbfd4a59af9f9b452e.png";